module.exports = __webpack_public_path__ + "static/img/vx_logo.8027a027.png";